import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Shell from "@/components/Shell";
import Orders from "@/pages/Orders";
import Analytics from "@/pages/Analytics";
import Menu from "@/pages/Menu";
import Inventory from "@/pages/Inventory";
import Offers from "@/pages/Offers";
import Ads from "@/pages/Ads";
import Payouts from "@/pages/Payouts";
import Outlet from "@/pages/Outlet";
import FareCalculator from "@/pages/FareCalculator";
import BrandKit from "@/pages/BrandKit";

function Protected({ children }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <Shell />
              </Protected>
            }
          >
            <Route path="/" element={<Navigate to="/orders" replace />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/inventory" element={<Inventory />} />
            <Route path="/offers" element={<Offers />} />
            <Route path="/ads" element={<Ads />} />
            <Route path="/payouts" element={<Payouts />} />
            <Route path="/outlet" element={<Outlet />} />
            <Route path="/fare" element={<FareCalculator />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/brand-kit" element={<BrandKit />} />
          </Route>
          <Route path="*" element={<Navigate to="/orders" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
